import { CUSTOM_INBOX } from '@disco/constants/GroupTypes'
import { isChannelShared } from '@disco/utils/groups'
import * as React from 'react'
import { useSelector } from 'hooks/use-redux'
import type { Group } from 'types/group'
import { getIsSubfolder } from '@disco/state-management/selectors/groups'
import ModalDialog from 'components/ui/modal-dialog'
export type Props = {
  onConfirm: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  group: Group
}

const DeleteGroupDialog = ({
  onConfirm,
  onCancel,
  group,
}: Props): React.ReactNode => {
  const isSubfolder = useSelector(state =>
    getIsSubfolder(state, {
      groupId: group.id,
    }),
  )
  const isInbox = group.group_type === CUSTOM_INBOX
  const isChannel = !group.parent
  let itemType

  if (isInbox) {
    itemType = 'custom inbox'
  } else if (isChannel) {
    itemType = 'channel'
  } else if (isSubfolder) {
    itemType = 'subfolder'
  } else {
    itemType = 'folder'
  }

  const isShared = isChannelShared(group)
  const groupName = group.name
  const isPartner = group.business_role === 'partner'
  return (
    <ModalDialog
      width={isShared || isPartner ? 'large' : undefined}
      title={
        isPartner
          ? `Are you sure you want your DISCO to leave this ${itemType}?`
          : isShared
          ? `Are you sure you want to delete this ${itemType}?`
          : `Delete ${itemType}`
      }
      primaryAction={{
        caption: isPartner ? `Leave ${itemType}` : 'Delete',
        onClick: onConfirm,
      }}
      status="danger"
      onCancel={onCancel}
    >
      {isPartner
        ? `If you leave this ${itemType}, you and everyone else in your DISCO will lose access to its content.`
        : isShared
        ? `This ${itemType} is shared with other DISCOs. If you delete this, the other DISCOs will no longer have access to this ${itemType} or it’s content`
        : `Are you sure you want to delete “${groupName}”? This can’t be undone.`}
    </ModalDialog>
  )
}

export default DeleteGroupDialog
